import { useTheme } from '../styled-components';
import { combineProps } from '../utils/combineProps';
/**
 * use combine props from default theme props
 *
 * @see stories {@link https://ringcentral.github.io/juno/?path=/story/api-reference-hooks-usethemeprops--page 🔧-foundation-hooks-usethemeprops--use-theme-props-example}
 */
export function useThemeProps(_a) {
    var props = _a.props, name = _a.name;
    var _b;
    var theme = useTheme();
    return combineProps((_b = theme.props) === null || _b === void 0 ? void 0 : _b[name], props);
}
